module.exports = __webpack_public_path__ + "img/about10.a3843bd.jpg";